/*
 * @Author: yuanweijiang
 * @Date: 2025-11-20 14:12:46
 * @LastEditors: yuanweijiang
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
// import Ssmap from "@/views/ssmap.vue";
// import ssmap_2 from "@/views/ssmap-2.vue";
import store from '@/store'
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: '',
    routes: [
        {
            path: '/',
            name: 'ssmap',
            component: () => import('@/views/ssmap.vue')
        },
        {
            path: '/sso',
            name: 'ssoCallback',
            component: () => import('@/views/SSOCallback.vue') // 创建专门的回调组件
        },
        {
            path: '/second-screen',
            name: 'ssmap_2',
            component: () => import('@/views/ssmap-2.vue')
        },
        // {
        //     path: '/',
        //     name: 'ssmap-offline',
        //     component: () => import('@/views/ssmap.vue')
        // },
        {
            path: '/home',
            name: 'home',
            component: () => import('@/views/home.vue')
        },
        {
            path: '/docx-preview',
            name: 'DocxPreview',
            component: () => import('@/components/homeContainer/docxPreview.vue'),
            meta: {
                title: '用户协议'
            }
        },
        {
            path: '/menu-view',
            name: 'menuVeiw',
            component: () => import('@/views/ssmap-3.vue')
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (process.env.NODE_ENV === 'offLine') {
        next()
        return
    }

    // 允许访问 SSO 回调页面和文档预览页面
    if (to.name == 'DocxPreview' || to.name == 'ssoCallback') {
        next()
        return
    }

    // 检查认证状态
    if (localStorage.getItem('userToken')) {
        store.commit('user/SET_TOKEN', localStorage.getItem('userToken'))
        store.commit('user/SET_USER_INFO', JSON.parse(localStorage.getItem('userInfo')))
        next()
    } else {
        // 重定向到 SSO 登录
        const ssoLoginUrl = '/authapi/auth/oauth2/authorize'
        const redirectUri = encodeURIComponent(window.location.origin + '/sso')
        const ssoUrl = `${ssoLoginUrl}?scope=server&redirect_uri=${redirectUri}&response_type=code&client_id=sscity`
        window.location.href = ssoUrl
    }
})
export default router
